import styles from './style.postcss';
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class Header extends PureComponent {
  getChildContext() {
    return { header: true };
  }

  render() {
    return <thead className={styles.SimpleTable_header}>{this.props.children}</thead>;
  }
}

Header.propTypes = {
  children: PropTypes.node,
};

Header.childContextTypes = {
  header: PropTypes.bool,
};

export default Header;



// WEBPACK FOOTER //
// ./components/SimpleTable/Header.jsx